import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router';

/** Redirección de una ruta vieja a la nueva sin perder la query ni el hash
 *  (un enlace guardado a una pestaña o filtro sigue funcionando). */
export function RedirectKeepingQuery({ to }: { to: string }): ReactElement {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
